import React, { useState  } from "react";
import { Row, Col, Input, Radio, Form,DatePicker,Modal,Button, } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Evaluation from "./Evaluation";
import { exportPathPdf } from "./ExportEvaluationPdf";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Select } from "antd";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { useParams } from "react-router-dom";
import axios from "axios"; // pour recupere le nom du patient 
import useToken from "../Authentication/useToken";
import i18next from "i18next";


dayjs.extend(isoWeek);
const dayMap = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 0,
};

const API_BASE_URL = "http://localhost:80"; // à placer en haut de ton fichier ou dans un fichier Constants.js

// Fonction d'export PDF modifiée qui gère correctement le token
const handleExportPathPdf = async (payload, token) => {
  if (!payload || !token) {
    console.error("Données manquantes pour l'exportation PDF");
    Modal.error({
      title: i18next.t("title_error"),
      content: i18next.t("error_missing_data_for_pdf_export"),
    });
    return;
  }

  try {
    await exportPathPdf(payload, token);
  } catch (error) {
    console.error("Erreur lors de l'exportation PDF PACE:", error);
    if (error.response) {
      console.error(
        "Réponse du serveur:",
        error.response.status,
        error.response.data
      );
    }
    Modal.error({
      title: i18next.t("error_pdf_export"),
      content: i18next.t("error_pdf_export_connexion"),
    });
  }
};

//pour les rappels d'evaluation 
const getReminderDates = (startDate, durationWeeks) => {
  const reminders = [];

  const reminderWeeks = {
    8: [8],
    12: [12],
    16: [8, 16],
    24: [12, 24],
  };

  const weeks = reminderWeeks[durationWeeks] || [];

  weeks.forEach((week) => {
    let date = dayjs(startDate).add(week, 'week');
    const day = date.day();

    // Si samedi ou dimanche, pousser au lundi suivant
    if (day === 0) date = date.add(1, 'day');
    else if (day === 6) date = date.add(2, 'day');

    // 👉 convertir en format ISO attendu par Sequelize/PostgreSQL
    reminders.push(date.toISOString());
  });

  return reminders;
};


function EvaluationPATH() {
  const { t } = useTranslation("Evaluations");
 const { patientId  } = useParams(); // récupère l'ID depuis l'URL
   console.log(" Paramètre URL (id) :", patientId ); // <--- AJOUT ICI
   const { token } = useToken(); // récupération du token d'auth
 
 
   //  Fonction définie proprement en dehors du useState
   const getInitialFormData = () => {
     const parsedId = parseInt(patientId, 10);
  return {

   idPatient: isNaN(parsedId) ? null : parsedId,

    // Section Cardio-musculaire
    chairTestSupport: true,
    chairTestCount: "",
    chairTestTime: "", //  Nouveau champ : temps pour répétitions


    // Section Équilibre
    balanceFeetTogether: "",
    balanceSemiTandem: "",
    balanceTandem: "",

    // Section Objectif de marche
    canWalk: true, // Définir une valeur par défaut (true) au lieu de undefined
    walkingTime: "",
    walkingAid: "", //  Nouveau champ : aide technique
   };
  };
    const [formData, setFormData] = useState(() => getInitialFormData());
    const [isScheduleModalVisible, setIsScheduleModalVisible] = useState(false);
    const [programStartDate, setProgramStartDate] = useState(null);
    const [programDurationWeeks, setProgramDurationWeeks] = useState(12);
    const [useCustomDuration, setUseCustomDuration] = useState(false);
    const [customDuration, setCustomDuration] = useState("");
    const [frequencyType, setFrequencyType] = useState("auto");
    const [customDays, setCustomDays] = useState([]);
    const generateCalendarEvents = async () => {
  console.log("ID Patient:", formData.idPatient);
  console.log("Start Date:", programStartDate?.toISOString());
  console.log("Custom Days:", customDays);

  const startDate = programStartDate;
  const weeks = useCustomDuration ? customDuration : programDurationWeeks;

  if (!startDate || !weeks || !formData?.idPatient) {
    console.log("Données manquantes :", { startDate, weeks, patientId: formData?.idPatient });
    return [];
  }

  // Étape 1 : Calculer les scores
  const scores = calculateScores(formData);
  const scoreLabel = `PATH ${scores.cardioMusculaire}${scores.equilibre}`;
  console.log("Label programme attendu:", scoreLabel);

  try {
    // Étape 2 : Requête vers le backend pour récupérer le bon programId
    const response = await axios.get(`${API_BASE_URL}/programs/by-name/${encodeURIComponent(scoreLabel)}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const programId = response.data?.id; // Vérifie que c’est bien la colonne `id`

    if (!programId) {
      console.error("Program ID non trouvé");
      return [];
    }

    // Étape 3 : Générer les sessions avec le bon programId
    const sessions = [];
    const start = dayjs(startDate);
    const end = start.add(Number(weeks), "week");
    let current = start.clone();

    while (current.isBefore(end)) {
      const day = current.day();

      const isSessionDay =
        frequencyType === "auto"
          ? true
          : customDays.includes(Object.keys(dayMap).find(key => dayMap[key] === day));

      if (isSessionDay) {
        const startStr = current.hour(14).minute(0).format();
        const endStr = current.hour(15).minute(0).format();

        sessions.push({
          name: "Séance Path",
          startDate: startStr,
          endDate: endStr,
          patientId: formData.idPatient,
          programId: programId,
        });
      }

      current = current.add(1, "day");
    }

    return sessions;

  } catch (error) {
    console.error("Erreur lors de la récupération du programme :", error);
    return [];
  }
};

const handlePlanifierSessions = async () => {
  const sessions = await generateCalendarEvents();

  if (sessions.length === 0) {
    Modal.error({
      title: "Erreur",
      content: "Aucune séance générée. Vérifiez les champs.",
    });
    return;
  }

  try {
    await axios.post("http://localhost:80/calendar-sessions/from-path", sessions, {
      headers: { Authorization: `Bearer ${token}` },
    });

    Modal.success({
      title: "Succès",
      content: "Les séances PATH ont été planifiées.",
    });

    setIsScheduleModalVisible(false);
  } catch (error) {
    console.error("Erreur PATH séance:", error);
    Modal.error({
      title: "Erreur",
      content: "Impossible d'enregistrer les séances PATH.",
    });
  }
};



  const calculateScores = (formData) => {
    const scoreCM = calculateChairTestScore(formData);
    const scoreBalance = calculateBalanceScore(formData, scoreCM);
    const programPath = scoreCM + "" + scoreBalance;

    return {
      cardioMusculaire: scoreCM,
      equilibre: scoreBalance,
      total: scoreCM + scoreBalance,
      program: programPath,
    };
  };

  const calculateChairTestScore = (formData) => {
    const count = parseInt(formData.chairTestCount);
    const withSupport = formData.chairTestSupport;

    if (isNaN(count) || count === 0) return 0;

    if (!withSupport) {
      // Sans appui
      if (count >= 10) return 5; // G ≥ 10 levers
      if (count >= 5 && count <= 9) return 4; // F 5-9 levers
      if (count >= 3 && count <= 4) return 3; // E 3 à 4 levers
      return 0;
    } else {
      // Avec appui
      if (count >= 10) return 3; // D ≥ 10 levers
      if (count >= 5 && count <= 9) return 2; // C 5-9 levers
      if (count < 5 && count > 0) return 1; // B < 5 levers
      return 0;
    }
  };

  const calculateBalanceScore = (formData, cardioScore) => {
    const feetTogether = parseFloat(formData.balanceFeetTogether || 0);
    const semiTandem = parseFloat(formData.balanceSemiTandem || 0);
    const tandem = parseFloat(formData.balanceTandem || 0);

    // Si le score cardio-musculaire est 0, seulement évaluer l'équilibre pieds joints
    if (cardioScore === 0) {
      return feetTogether >= 5 ? 1 : 0;
    }

    // Vérifier dans l'ordre selon le document
    if (tandem >= 3) return 4;
    if (semiTandem >= 5) return 3;
    if (semiTandem < 5 && semiTandem > 0) return 2;
    if (feetTogether >= 5) return 1;
    return 0;
  };

  const buildPayload = (formData, scores, patientId, isBalanceTestEnabled) => {
    return {
      idPatient: patientId,
      chairTestSupport: formData.chairTestSupport ? "with" : "without",
      chairTestCount: parseInt(formData.chairTestCount || 0, 10), // Ajouter || 0 pour éviter NaN
      chairTestTime: parseFloat(formData.chairTestTime || 0), // ✅

      balanceFeetTogether: parseFloat(formData.balanceFeetTogether || 0, 10),
      balanceSemiTandem: isBalanceTestEnabled("balanceSemiTandem")
        ? parseFloat(formData.balanceSemiTandem || 0, 10)
        : 0,
      balanceTandem: isBalanceTestEnabled("balanceTandem")
        ? parseFloat(formData.balanceTandem || 0, 10)
        : 0,
      // Conditionnellement définir walkingTime en fonction de canWalk
      walkingTime: formData.canWalk ? parseFloat(formData.walkingTime || 0) : 0,
      canWalk: !!formData.canWalk, // S'assurer que la valeur est un booléen
      walkingAid: formData.walkingAid, // ✅

      scores: {
        cardioMusculaire: scores.cardioMusculaire,
        equilibre: scores.equilibre,
        total: scores.total,
        program: scores.program,
      },
    };
  };

  const buildModalContent = (scores, formData) => {
    return (
      <div className="results-container">
        <h3
          style={{
            marginBottom: "20px",
            borderBottom: "1px solid #eee",
            paddingBottom: "10px",
          }}
        >
          {t("title_results_eval_path")}
        </h3>

        <div style={{ marginBottom: "15px" }}>
          <strong>{t("text_individual_scores")} :</strong>
          <p>
            {t("text_cardio_score")} : {scores.cardioMusculaire}/5
          </p>
          <p>
            {t("text_balance_score")} : {scores.equilibre}/4
          </p>
        </div>

        {/* Nouveau style avec fond grisé comme dans MATCH */}
        <div
          style={{
            marginTop: "20px",
            backgroundColor: "#f5f5f5",
            padding: "15px",
            borderRadius: "5px",
          }}
        >
          <p>
            <strong>
              {t("title_path_program")} : {scores.program}
            </strong>
          </p>
        </div>

        {/* Si canWalk === true ET walkingTime, on affiche la vitesse */}
        {formData.canWalk && formData.walkingTime && (
          <div
            style={{
              marginTop: "20px",
              borderTop: "1px solid #eee",
              paddingTop: "15px",
            }}
          >
            <p>
              {t("text_walk_speed")} : {calculateSpeed(formData.walkingTime)}{" "}
              {t("text_speed_unit")}
            </p>
            <p>
              <strong>
                {t("text_daily_walking_goal")} :{" "}
                {calculateWalkingObjective(formData.walkingTime)} minutes
              </strong>
            </p>
          </div>
        )}

        {/* Sinon, s'il ne peut pas marcher */}
        {formData.canWalk === false && (
          <div
            style={{
              marginTop: "20px",
              borderTop: "1px solid #eee",
              paddingTop: "15px",
            }}
          >
            <p>
              <strong>{t("text_walking_capacity_to_improve")}</strong>
            </p>
          </div>
        )}
        <div style={{ marginTop: "20px" }}>
  
</div>

      </div>
      
    );
  };

  const calculateSpeed = (walkingTime) => {
    const time = parseFloat(walkingTime);
    if (isNaN(time) || time <= 0) return "0.00";
    return (4 / time).toFixed(2);
  };

  const calculateWalkingObjective = (walkingTime) => {
    const time = parseFloat(walkingTime);

    if (isNaN(time) || time < 0 || walkingTime === "") {
      return null;
    }

    if (time === 0) {
      return 10;
    }

    const speed = 4 / time;

    if (speed < 0.4) return 10;
    if (speed >= 0.4 && speed < 0.6) return 15;
    if (speed >= 0.6 && speed < 0.8) return 20;
    if (speed >= 0.8) return 30;

    return null;
  };

  const renderFormFields = (
    formData,
    handleChange,
    errors,
    isBalanceTestEnabled
  ) => {
    return (
      <>
        {/* Section A: CARDIO-MUSCULAIRE */}
        <h2>{t("title_sectionA")}</h2>
        <Form.Item label={t("label_chair_test")}>
          <Radio.Group
            name="chairTestSupport"
            value={formData.chairTestSupport}
            onChange={(e) =>
              handleChange({
                target: { name: "chairTestSupport", value: e.target.value },
              })
            }
          >
            <Radio value={true}>{t("radio_with_support")}</Radio>
            <Radio value={false}>{t("radio_without_support")}</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={t("label_stand_count")}
          validateStatus={errors.chairTestCount ? "error" : ""}
          help={errors.chairTestCount}
        >
          <Input
            name="chairTestCount"
            value={formData.chairTestCount}
            onChange={handleChange}
            placeholder={t("placeholder_stand_count")}
          />
        </Form.Item>
        <Form.Item
  label="Temps pour 5 répétitions (en secondes)"
  validateStatus={errors.chairTestTime ? "error" : ""}
  help={errors.chairTestTime}
>
  <Input
    name="chairTestTime"
    value={formData.chairTestTime}
    onChange={handleChange}
    placeholder="Ex: 30.5"
    type="number"
    min={0}
  />
</Form.Item>

        {/* Section B: ÉQUILIBRE */}
        <h2>{t("title_sectionB")}</h2>
        <div
          style={{ marginBottom: "15px", fontStyle: "italic", color: "#666" }}
        >
          <InfoCircleOutlined style={{ marginRight: "5px" }} />
          {t("info_path_evaluation_1")}
          <br />
          <InfoCircleOutlined style={{ marginRight: "5px" }} />
          {t("info_path_evaluation_2")}
        </div>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
               label={
                <span style={{ display: "flex", alignItems: "center" }}>
                  {t("label_feet_together")}
                  <img
                    src={require("./images/pace_balance_joint.png")}
                    alt="Joint Feet"
                    style={{ marginLeft: 8, height: 24 }}
                  />
                </span>
              }
              validateStatus={errors.balanceFeetTogether ? "error" : ""}
              help={errors.balanceFeetTogether}
            >
              <Input
                name="balanceFeetTogether"
                value={formData.balanceFeetTogether}
                onChange={handleChange}
                placeholder={t("placeholder_time")}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
               label={
                <span style={{ display: "flex", alignItems: "center" }}>
                  {t("label_feet_semi_tandem")}
                  <img
                    src={require("./images/pace_balance_semi_tandem.png")}
                    alt="Semi tandem Feet"
                    style={{ marginLeft: 8, height: 24 }}
                  />
                </span>
              }
              validateStatus={errors.balanceSemiTandem ? "error" : ""}
              help={errors.balanceSemiTandem}
            >
              <Input
               className="half-width-input"

                name="balanceSemiTandem"
                value={formData.balanceSemiTandem}
                onChange={handleChange}
                placeholder={t("placeholder_time")}
                disabled={!isBalanceTestEnabled("balanceSemiTandem")}
              />
              
                        {formData.balanceSemiTandem && (
               <Form.Item
                 label="Quel pied est devant ?"
                 validateStatus={errors.balanceSemiTandemSupport ? "error" : ""}
                 help={errors.balanceSemiTandemSupport}
               >
                 <Radio.Group
                   name="balanceSemiTandemSupport"
                   value={formData.balanceSemiTandemSupport}
                   onChange={(e) =>
                     handleChange({
                       target: { name: "balanceSemiTandemSupport", value: e.target.value },
                     })
                   }
                 >
                   <Radio value="gauche">Gauche</Radio>
                   <Radio value="droit">Droit</Radio>
                 </Radio.Group>
               </Form.Item>
             )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={
                <span style={{ display: "flex", alignItems: "center" }}>
                  {t("label_feet_tandem")}
                  <img
                    src={require("./images/pace_balance_tandem.png")}
                    alt="Tandem Feet"
                    style={{ marginLeft: 8, height: 24 }}
                  />
                </span>}
              validateStatus={errors.balanceTandem ? "error" : ""}
              help={errors.balanceTandem}
            >
              <Input
                name="balanceTandem"
                value={formData.balanceTandem}
                onChange={handleChange}
                placeholder={t("placeholder_time")}
                disabled={!isBalanceTestEnabled("balanceTandem")}
              />
               {formData.balanceTandem && (
                <Form.Item
                  label="Quel pied est devant ?"
                  validateStatus={errors.balanceTandemSupport ? "error" : ""}
                  help={errors.balanceTandemSupport}
                >
                  <Radio.Group
                    name="balanceTandemSupport"
                    value={formData.balanceTandemSupport}
                    onChange={(e) =>
                      handleChange({
                        target: { name: "balanceTandemSupport", value: e.target.value },
                      })
                    }
                  >
                    <Radio value="gauche">Gauche</Radio>
                    <Radio value="droit">Droit</Radio>
                  </Radio.Group>
                </Form.Item>
              )}
              
            </Form.Item>
          </Col>
        </Row>

        {/* Section C: OBJECTIF DE MARCHE */}
        <h2>{t("title_SectionC_path_match_evaluation")}</h2>
        <Form.Item label={t("label_match_walk_objective")}>
          <Radio.Group
            name="canWalk" // Ajouter le nom pour le handleChange
            value={formData.canWalk}
            onChange={(e) =>
              handleChange({
                target: { name: "canWalk", value: e.target.value },
              })
            }
            style={{ marginBottom: "16px" }}
          >
            <Radio value={true}>{t("radio_patient_can_walk")}</Radio>
            <Radio value={false}>{t("radio_patient_cannot_walk")}</Radio>
          </Radio.Group>

          {formData.canWalk && (
            <Form.Item
              label={t("label_time_needed_walk_4m")}
              validateStatus={errors.walkingTime ? "error" : ""}
              help={errors.walkingTime}
            >
              <Input
                name="walkingTime"
                value={formData.walkingTime}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || /^\d*\.?\d*$/.test(value)) {
                    handleChange(e);
                  }
                }}
                placeholder={t("walktime_placeholder")}
              />
              {formData.walkingTime && !errors.walkingTime && (
                <div style={{ marginTop: 8, color: "#666" }}>
                  {t("text_walk_speed")} :{" "}
                  {calculateSpeed(formData.walkingTime)} m/s
                  <div style={{ marginTop: 4 }}>
                    <strong>
                      {t("text_daily_walking_goal")} :{" "}
                      {calculateWalkingObjective(formData.walkingTime)}{" "}
                      {t("text_minutes_per_day")}
                    </strong>
                  </div>
                </div>
              )}
            </Form.Item>
          )}
        </Form.Item>
        {formData.canWalk && (
  <Form.Item label="Type d'aide technique utilisée">
    <Radio.Group
      name="walkingAid"
      value={formData.walkingAid}
      onChange={(e) =>
        handleChange({
          target: { name: "walkingAid", value: e.target.value },
        })
      }
    >
      <Radio value="aucune">Aucune aide technique</Radio>
      <Radio value="canne">Canne</Radio>
      <Radio value="marchette">Marchette</Radio>
      <Radio value="deambulateur">Déambulateur</Radio>
      <Radio value="autre">Autre</Radio>
    </Radio.Group>
  </Form.Item>
)}
<Modal
   title="Planification des séances PATH"
  open={isScheduleModalVisible}
  onCancel={() => setIsScheduleModalVisible(false)}
  onOk={handlePlanifierSessions}
  okText="Planifier"
  cancelText="Annuler"
  destroyOnClose={true}
>
  <p>
    <strong>Date de début du programme :</strong>{" "}
    {programStartDate
      ? dayjs(programStartDate).format("DD/MM/YYYY")
      : "Aucune date sélectionnée"}
  </p>

  <Form.Item label="Choisir une date de début">
    <DatePicker
      value={programStartDate}
      onChange={(date) => setProgramStartDate(date)}
    />
  </Form.Item>

  <Form.Item label="Durée par défaut">
    <Input value={`${programDurationWeeks} semaines`} disabled />
  </Form.Item>

  <Form.Item>
    <Radio.Group
      onChange={(e) => setUseCustomDuration(e.target.value)}
      value={useCustomDuration}
    >
      <Radio value={false}>Utiliser la durée par défaut</Radio>
      <Radio value={true}>Spécifier une durée personnalisée</Radio>
    </Radio.Group>
  </Form.Item>

  {useCustomDuration && (
    <Form.Item label="Durée personnalisée (en semaines)">
      <Select
        value={customDuration}
        onChange={(value) => setCustomDuration(value)}
        placeholder="Choisir une durée"
      >
        <Select.Option value={8}>8 semaines</Select.Option>
        <Select.Option value={16}>16 semaines</Select.Option>
        <Select.Option value={24}>24 semaines</Select.Option>
      </Select>
    </Form.Item>
  )}

  <Form.Item label="Date de fin estimée">
    <Input
      value={
        programStartDate
          ? dayjs(programStartDate)
              .add(Number(useCustomDuration ? customDuration : programDurationWeeks), "week")
              .format("DD/MM/YYYY")
          : "Aucune date sélectionnée"
      }
      disabled
    />
  </Form.Item>

  <Form.Item label="Fréquence des séances">
    <Radio.Group
      onChange={(e) => setFrequencyType(e.target.value)}
      value={frequencyType}
    >
      <Radio value="auto">1 séance par jour</Radio>
      <Radio value="custom">Choisir les jours manuellement</Radio>
    </Radio.Group>
  </Form.Item>

  {frequencyType === "custom" && (
    <Form.Item label="Jours de la semaine">
      <Select
        mode="multiple"
        value={customDays}
        onChange={setCustomDays}
        placeholder="Sélectionner les jours"
      >
        <Select.Option value="monday">Lundi</Select.Option>
        <Select.Option value="tuesday">Mardi</Select.Option>
        <Select.Option value="wednesday">Mercredi</Select.Option>
        <Select.Option value="thursday">Jeudi</Select.Option>
        <Select.Option value="friday">Vendredi</Select.Option>
      </Select>
    </Form.Item>
    
  )}

 <Button type="primary" onClick={handlePlanifierSessions}>
  Générer les séances
</Button>


</Modal>

  
      </>
      
    );
  };
  const handleCustomConfirm = () => {
  setProgramDurationWeeks(12);
  setIsScheduleModalVisible(true);
};

  
  return (
    <Evaluation
      evaluationType="PACE"
      getInitialFormData={getInitialFormData} // ✅ AJOUT ICI

      calculateScores={calculateScores}
      renderFormFields={renderFormFields}
      buildPayload={(formData, scores, patientId, isBalanceTestEnabled) =>
      buildPayload(formData, scores, patientId, isBalanceTestEnabled, {
        programStartDate,
        programDurationWeeks: useCustomDuration ? customDuration : programDurationWeeks,
        frequencyType,
        customDays,
      })
    }

      buildModalContent={(scores) => buildModalContent(scores)}
     
      exportPdf={handleExportPathPdf}
      idPatient={parseInt(patientId, 10)} 
      onCustomConfirm={handleCustomConfirm} // ✅ Ici c'est ta propre fonction
       

    />
  );
  }
EvaluationPATH.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};
export default EvaluationPATH;
